module.exports = __webpack_public_path__ + "img/cerrado.2803bb3b.svg";